import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Matches versions like: 1.2.3
// Does NOT allow: v1.2.3, 1.2, 1.2.3.4, 01.2.3
const SEMVER_REGEX = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)$/;

export function semverValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        // Let required validator handle empty values
        if (!control.value) {
            return null;
        }

        const isValid = SEMVER_REGEX.test(control.value);
        return isValid ? null : { semverInvalid: true };
    };
}
